/* eslint-disable */

import comparisonData from '@data/comparison-data.json';
import data from '@data/data';

export function getRegion(pillarsStore) {
  return (
    pillarsStore[0]?.answers[0].value.find(
      ({ questionIndex }) => questionIndex === 0
    ).answer || ''
  );
}

export function getQuestion(pillarIndex, questionIndex) {
  const { question, answers, maxScore } =
    data.the_assessment.content[0].pillars[pillarIndex].questions[
      questionIndex
    ];

  return { question, answers, maxScore: maxScore || 0 };
}

function getScore(question, option, answer) {
  // Pillar 2

  if (
    question ===
    'Do you believe that your organization has the right skills to select the right model for the right use case?'
  ) {
    return {
      Yes: 5,
      No: 1,
    }[answer];
  }

  if (
    question ===
    'How would you assess your ability to use different techniques (RAG, prompt engineering, fine tuning etc) for getting the most accurate results for different use cases?'
  ) {
    return {
      'We have built significant capabilities for using different techniques for different use cases': 5,
      'We have some general capabilities but are not yet able to master these techniques for different use cases': 3,
      'We are at the early stages of building our capabilities': 1,
    }[answer];
  }

  if (
    question ===
    'How would you assess your capabilities for assessing the cost and ROI of using different techniques (RAG, prompt engineering, fine tuning etc) for different use cases?'
  ) {
    return {
      'We have built significant capabilities for assessing cost and ROI': 5,
      'We have some general capabilities but are not yet able to make decent assessments': 3,
      'We are at the early stages of building our capabilities': 1,
    }[answer];
  }

  if (
    question ===
    'Which of the following levels of MLOps maturity most closely aligns with your organization?'
  ) {
    return {
      'There are no formal or consistent processes for developing, deploying, or monitoring ML models. Projects are executed in isolation, with no  collaboration or integration with other teams or systems': 0,
      'Some fundamental MLOps practices and capabilities have been introduced. There is some collaboration and integration with other teams and systems and automation tools such as scripts and pipelines have started to be used': 3,
      'MLOps practices and capabilities such as CI/CD and continuous monitoring have been adopted. Robust and scalable automation tools such as orchestration platforms and cloud services are used for deploying ML models': 4,
      'MLOps practices have been fully integrated and optimized across the organization. Projects are aligned with business goals and outcomes, with clear and measurable value and impact. State-of-the-art automation tools such as serverless or edge computing are used for deploying ML models': 5,
    }[answer];
  }

  // Pillar 3

  if (
    question ===
    'When it comes to hiring and reskilling in specific areas relating to GenAI (eg prompt engineering) which of the following statements most closely aligns with your organization?'
  ) {
    return {
      'We are still assessing the skills that we need': 1,
      'We are in the process of recruiting skills to our central data /AI team': 3,
      'We have skilled up multiple teams and recruited a large number of skills in different AI categories': 5,
    }[answer];
  }

  if (
    [
      'Do you have a CXO (for example a Chief Digital Officer or a Chief AI Officer) role whose time and responsibilities are predominantly (more than 50%) focussed on AI?',
      'Do you have a central AI office / center of excellence that is responsible for AI governance?',
      'Do you have dedicated AI roles and accountabilities in different parts of the business (eg product, network, marketing)?',
    ].includes(question)
  ) {
    return {
      Yes: 5,
      No: 0,
    }[answer];
  }

  // Pillar 4

  if (
    question ===
    'How does your data perform in terms of the following dimensions and capabilities?'
  ) {
    return parseInt(answer);
  }

  // Pillar 5

  if (question === 'Does your GenAI governance include the following?') {
    return {
      yes: 5,
      no: 1,
    }[answer];
  }

  // Pillar 6

  if (
    question ===
    'Which of the following domains / use cases are you building GenAI applications for today?'
  ) {
    return {
      Evaluating: 0,
      'Building POCs / MVPs': 1,
      'Putting into production': 2,
    }[answer];
  }

  if (
    question ===
    'What are your business objectives today for the application of GenAI in different departments within your organization?'
  ) {
    return {
      'Evenly divided between efficiency and value creation': 2.5,
      'Principally value creation': 2,
      'Principally efficiency gains': 1.5,
    }[answer];
  }

  // Pillar 7

  if (
    question ===
    'Where are you today in terms of putting GenAI use cases into production?'
  ) {
    return {
      'We are observing what other CSPs are doing with a view to setting up experiments / POCs': 0,
      'We have created some POCs but have not converted these into full deployments': 2.2,
      'We have deployed a handful of use cases but have not yet built an AI pipeline': 4.4,
      'We have deployed a number of use cases and have a strong pipeline': 6.6,
    }[answer];
  }

  if (question === 'How many GenAI use cases do you have in production?') {
    return {
      0: 0,
      '1-2': 1.7,
      '3-5': 3.4,
      '6-10': 5.1,
      '>10': 6.8,
    }[answer];
  }

  if (
    question ===
    'For the POCs that have moved into production, which of the following statements is closest to how you have approached your choice of LLM and how you have gone about achieving the best results?'
  ) {
    return {
      'We have not moved any POCs into production': 0,
      'We tested multiple LLMs before selecting the one that delivered the right result': 2.2,
      'We assessed the merits of using techniques such as RAG and prompt engineering and used them where necessary': 4.4,
      'We tested multiple LLMs and, where necessary, fine-tuned the model. In addition, we assessed the merits of using techniques such as RAG and prompt engineering and used them where necessary': 6.6,
    }[answer];
  }

  return 0;
}

function getComparisonScore(question, option) {
  return (
    comparisonData[
      {
        // Pillar 2
        'Do you believe that your organization has the right skills to select the right model for the right use case?':
          '11 Do you believe that your organization has the right skills to select the right model for the right use case? Response',
        'How would you assess your ability to use different techniques (RAG, prompt engineering, fine tuning etc) for getting the most accurate results for different use cases?':
          '13 How would you assess your ability to use different techniques (RAG, prompt engineering, fine tuning etc) for getting the most accurate results for different use cases? (choose one) Response',
        'How would you assess your capabilities for assessing the cost and ROI of using different techniques (RAG, prompt engineering, fine tuning etc) for different use cases?':
          '15 How would you assess your capabilities for assessing the cost and ROI of using different techniques (RAG, prompt engineering, fine tuning etc) for different use cases? (choose one) Response',
        'Which of the following levels of MLOps maturity most closely aligns with your organization?':
          '19 Which of the following levels of MLOps maturity most closely aligns with your organization? (choose one) Response',
        // Pillar 3
        'When it comes to hiring and reskilling in specific areas relating to GenAI (eg prompt engineering) which of the following statements most closely aligns with your organization?':
          '21 When it comes to hiring and reskilling in specific areas relating to GenAI (eg prompt engineering) which of the following statements most closely aligns with your organization? (choose one) Response',
        'Do you have a CXO (for example a Chief Digital Officer or a Chief AI Officer) role whose time and responsibilities are predominantly (more than 50%) focussed on AI?':
          '23 Do you have a CXO (for example a Chief Digital Officer or a Chief AI Officer) role whose time and responsibilities are predominantly (more than 50%) focussed on AI? Response',
        'Do you have a central AI office / center of excellence that is responsible for AI governance?':
          '24 Do you have a central AI office / center of excellence that is responsible for AI governance? Response',
        'Do you have dedicated AI roles and accountabilities in different parts of the business (eg product, network, marketing)?':
          '25 Do you have dedicated AI roles and accountabilities in different parts of the busines (eg product, network, marketing)? Response',
        // Pillar 7
        'Where are you today in terms of putting GenAI use cases into production?':
          '63 Where are you today in terms of putting GenAI use cases into production Response',
        'How many GenAI use cases do you have in production?':
          '65 How many GenAI use cases do you have in production? Response',
        'For the POCs that have moved into production, which of the following statements is closest to how you have approached your choice of LLM and how you have gone about achieving the best results?':
          'For the POCs that have moved into production, which of the following statements is closest to how you have approached your choice of LLM and how you have gone about achieving the best results?',
      }[question]
    ] ||
    comparisonData[
      {
        // Pillar 4
        'How does your data perform in terms of the following dimensions and capabilities? Rapid access to the data':
          '30 How does your data perform in terms of the following dimensions and capabilities? (5 = excellent and 1 = poor) Rapid access to the data',
        'How does your data perform in terms of the following dimensions and capabilities? Access to trustworthy data':
          '31 Access to trustworthy data',
        'How does your data perform in terms of the following dimensions and capabilities? Access to high-quality structured data':
          '32 Access to high-quality structured data',
        'How does your data perform in terms of the following dimensions and capabilities? Access to high-quality unstructured data':
          '33 Access to high-quality unstructured data',
        'How does your data perform in terms of the following dimensions and capabilities? Access to streaming data':
          '34 Access to streaming data',
        // Pillar 5
        'Does your GenAI governance include the following? A GenAI platform that handles aspects relating to security / compliance / cost issues':
          '35 Does your GenAI governance include the following? A GenAI platform that handles aspects relating to security / compliance / cost issues',
        'Does your GenAI governance include the following? A cross-functional GenAI center of excellence (COE) to supplement a central function':
          '36 A cross-functional GenAI center of excellence (COE) to supplement a central function',
        'Does your GenAI governance include the following? A core governing body, including an ultimate decision-maker for the organization’s GenAI agenda':
          '37 A core governing body, including an ultimate decision-maker for the organization’s GenAI agenda',
        'Does your GenAI governance include the following? A well-defined process / policy that reviews the model / use cases and addresses potential negative impact':
          '38 A well-defined process / policy that reviews the model / use cases and addresses potential negative impact',
        // Pillar 6
        'Which of the following domains / use cases are you building GenAI applications for today? Chatbots':
          '41 Which of the following domains / use cases are you building GenAI applications for today? Chatbot',
        'Which of the following domains / use cases are you building GenAI applications for today? Summarization':
          '42 Summarization',
        'Which of the following domains / use cases are you building GenAI applications for today? Document creation':
          '43 Document creation',
        'Which of the following domains / use cases are you building GenAI applications for today? Code creation':
          '44 Code creation',
        'Which of the following domains / use cases are you building GenAI applications for today? Content creation':
          '45 Content creation',
        'What are your business objectives today for the application of GenAI in different departments within your organization? IT function':
          '47 What are your business objectives today for the application of GenAI in different departments within your organization? Internal IT',
        'What are your business objectives today for the application of GenAI in different departments within your organization? Network operations':
          '48 Network operations',
        'What are your business objectives today for the application of GenAI in different departments within your organization? Sales and marketing':
          '49 Sales and marketing',
        'What are your business objectives today for the application of GenAI in different departments within your organization? Product organizations (for the creation of new / enhanced products)':
          '50 Product organizations (for the creation of new / enhanced products)',
      }[[question, option].join(' ')]
    ] ||
    {}
  );
}

export function getQuestionScores(
  pillarsStore,
  pillarIndex,
  questionIndex,
  region
) {
  let score = 0;
  let globalScore = 0;
  let regionScore = 0;
  let marketLeaderScore = 0;

  for (const answer of pillarsStore[pillarIndex]?.answers || []) {
    for (const value of answer.value) {
      if (value.questionIndex === questionIndex) {
        const question =
          data.the_assessment.content[0].pillars[pillarIndex].questions[
            value.questionIndex
          ];
        score += getScore(question.question, value.question, value.answer);
        const comparisonScores = getComparisonScore(
          question.question,
          value.question
        );
        globalScore += comparisonScores.score || 0;
        regionScore += comparisonScores[region] || 0;
        marketLeaderScore += comparisonScores.marketLeader || 0;
      }
    }
  }

  const scores = [
    Math.round(score),
    Math.round(globalScore),
    Math.round(regionScore),
    Math.round(marketLeaderScore),
  ];

  return scores;
}

export function getBarScores(
  pillarsStore,
  pillarIndex,
  questionIndex,
  answers,
  region
) {
  return answers.map(({ text }, index) => {
    let score = 0;
    let globalScore = 0;
    let regionScore = 0;
    let marketLeaderScore = 0;

    const _question =
      data.the_assessment.content[0].pillars[pillarIndex].questions[
        questionIndex
      ];
    const { question, answer } =
      pillarsStore[pillarIndex]?.answers[questionIndex].value.find(
        ({ question }) => question === text
      ) || {};

    if (question && answer) {
      score += getScore(_question.question, question, answer);
      const comparisonScores = getComparisonScore(_question.question, question);
      globalScore += comparisonScores.score || 0;
      regionScore += comparisonScores[region] || 0;
      marketLeaderScore += comparisonScores.marketLeader || 0;
    }

    const scores = [
      Math.round(score),
      Math.round(globalScore),
      Math.round(regionScore),
      Math.round(marketLeaderScore),
    ];

    return {
      label: text,
      scores,
    };
  });
}

export function getPillarScores(pillarIndex, pillarsStore, region) {
  let score = 0;
  let globalScore = 0;
  let regionScore = 0;
  let marketLeaderScore = 0;

  for (const answer of pillarsStore[pillarIndex]?.answers || []) {
    for (const value of answer.value) {
      const question =
        data.the_assessment.content[0].pillars[pillarIndex].questions[
          value.questionIndex
        ];
      score += getScore(question.question, value.question, value.answer);
      const comparisonScores = getComparisonScore(
        question.question,
        value.question
      );
      globalScore += comparisonScores.score || 0;
      regionScore += comparisonScores[region] || 0;
      marketLeaderScore += comparisonScores.marketLeader || 0;
    }
  }

  const scores = [
    Math.round(score),
    Math.round(globalScore),
    Math.round(regionScore),
    Math.round(marketLeaderScore),
  ];

  return scores;
}

export function getAllScores(pillarsStore, region) {
  return data.introduction.content
    .find(({ pillarList }) => pillarList)
    .pillarList.map(({ title, pillarIndex }) => {
      return {
        label: title,
        scores: getPillarScores(pillarIndex, pillarsStore, region),
      };
    });
}

export function queryScoresToJson(query) {
  const json = {};

  const pairs = query.split('&');

  pairs.forEach((pair) => {
    const keys = pair.replace('?', '').split('.');

    const currentPillar = keys[0];
    if (!json[currentPillar]) {
      json[currentPillar] = {};
    }

    keys.shift();
    let lastKey = null;
    keys.forEach((key, keyIndex) => {
      if (keyIndex === 0) {
        if (key.includes('=')) {
          const [keyName, keyValue] = key.split('=');
          json[currentPillar][keyName] = decodeURIComponent(keyValue);
        } else {
          json[currentPillar][key] = {
            ...json[currentPillar][key],
          };
        }

        lastKey = key;
      } else {
        // Nested Content
        if (key.includes('=')) {
          const [keyName, keyValue] = key.split('=');
          json[currentPillar][lastKey] = {
            ...json[currentPillar][lastKey],
            [keyName]: decodeURIComponent(keyValue),
          };
        }
      }
    });
  });

  return json;
}
